/**
 * Density — how tightly the design system pieces are laid out (shared spec:
 * packages/ui textRoles.ts `compactSpec`). `default` for record and work
 * screens (Customers, My Work, Help); `compact` for data-heavy screens
 * (Reports, big tables). A page wraps itself in `<DensityProvider
 * density="compact">` and every SectionBox, SegmentedTabs and Button inside
 * follows; a component's own `density` prop wins over the provider. Phones
 * keep 44px touch targets either way (the `compactVars` CSS variables).
 */
import React, { createContext, useContext } from 'react';
import type { Density } from '@turn-connect/ui';

const DensityContext = createContext<Density>('default');

export const DensityProvider: React.FC<{ density: Density; children?: React.ReactNode }> = ({ density, children }) => (
  <DensityContext.Provider value={density}>{children}</DensityContext.Provider>
);

/** The density to draw with: the component's own prop, else the nearest provider, else `default`. */
export function useDensity(own?: Density): Density {
  const inherited = useContext(DensityContext);
  return own ?? inherited;
}
